/**
 * Converts an unknown value to a number, returning `null` for values that
 * cannot be meaningfully converted (`null`, `undefined`, empty string, `NaN`).
 */
export const parseNumber = (v: unknown): number | null => {
    if (v === null || v === undefined || v === '') return null;
    const n = Number(v);
    return Number.isNaN(n) ? null : n;
};
